'use client';

import React from 'react';
import { DrawerBackdrop, DrawerContent, DrawerRoot } from '@/components/ui/chakra/drawer';
import { useCartDrawer } from '@/contexts/cartDrawerContext';
import { IconButton } from '@chakra-ui/react';
import CartCloseIcon from './components/CartCloseIcon';
import ShoppingBagSkeleton from './ShoppingBagSkeleton';
import QueryBoundary from '@/components/ui/QueryBoundary';
import ShoppingBagDrawerContent from './ShoppingBagDrawerContent';

const ShoppingBagDrawer = () => {
  const { isOpen, onCartClose, onSetCartState } = useCartDrawer();

  return (
    <DrawerRoot onOpenChange={(e) => onSetCartState(e.open)} open={isOpen} initialFocusEl={() => null}>
      <DrawerBackdrop />
      <DrawerContent
        maxWidth={{
          base: '100%',
          mobile: '450px',
          tablet: '450px',
          desktop: '450px',
        }}
        position="relative"
        alignItems="center"
        justifyContent="center"
        backgroundColor="white"
        width="100%"
        tabIndex={isOpen ? undefined : -1}
        aria-hidden={!isOpen}
      >
        <IconButton
          _hover={{ backgroundColor: 'transparent' }}
          aria-label="Close cart"
          backgroundColor="transparent"
          border="none"
          cursor="pointer"
          position="absolute"
          top="16px"
          left="16px"
          zIndex="banner"
          onClick={onCartClose}
          tabIndex={isOpen ? 0 : -1}
        >
          <CartCloseIcon />
        </IconButton>
        <QueryBoundary loadingFallback={<ShoppingBagSkeleton />}>
          <ShoppingBagDrawerContent />
        </QueryBoundary>
      </DrawerContent>
    </DrawerRoot>
  );
};

export default ShoppingBagDrawer;
